import { type AirHandlerUnit, type BoilerRoom, type Module } from "@eisox/api/core-api";

interface SupervisableModulesParams {
  boilerRooms: BoilerRoom[];
  airHandlerUnits: AirHandlerUnit[];
  modules: Module[];
}

/**
 * A site is only "supervisable" — and thus gets the alarms page + sidebar entry — when it has a GTB
 * (a proxy-enabled module), a boiler room, or an air handler unit.
 */
export const buildingHasSupervisableModules = ({
  boilerRooms,
  airHandlerUnits,
  modules,
}: SupervisableModulesParams): boolean =>
  modules.some(module => module.proxy?.isEnabled) || boilerRooms.length > 0 || airHandlerUnits.length > 0;
